import TestarossaDefault from './TestarossaDefault'

export default TestarossaDefault
// eslint-disable-next-line import/export
export * from './TestarossaDefault'
